<template>
  <div>
    <logo-plain
      :image-src="$t('PROVIDER_LOGO_WHITE_BACKGROUND')"
    />

    <hero-plain
      :image-src="bannerImageSrc"
    />

    <about-cta
      :title="$t('ORTHODONTICS_OVERALL_ABOUT_SECTION_TITLE')"
      :body="$t('ORTHODONTICS_OVERALL_ABOUT_SECTION_TEXT')"
    />

    <testimonials
      :review1="review1"
    />

    <how-it-works
      :title="$t('ORTHODONTICS_HOW_IT_WORKS_SECTION_TITLE')"
      :body="$t('ORTHODONTICS_HOW_IT_WORKS_SECTION_TEXT')"
      :bullets="howItWorksBullets"
      :demo-video-id="demoVideoIdHowItWorks"
      :image-src="demoImageHowItWorks"
      :avatar-image-src="demoAvatarImageHowItWorks"
      :avatar-text="$t('HOW_IT_WORKS_SECTION_AVATAR_TEXT')"
    />

    <how-to-video
      :title="$t('ORTHODONTICS_HOW_TO_TAKE_IMAGES_SECTION_TITLE')"
      :body="$t('ORTHODONTICS_HOW_TO_TAKE_IMAGES_SECTION_TEXT')"
      :demo-video-id="demoVideoIdHowToVideo"
    />

    <how-it-works
      :title="$t('ORTHODONTICS_WHAT_HAPPENS_NEXT_SECTION_TITLE')"
      :body="$t('ORTHODONTICS_WHAT_HAPPENS_NEXT_SECTION_TEXT')"
      :bullets="whatHappensNextBullets"
    />

    <!-- NOTE: HACK for now to make a separator. TODO: Make a separator :-) -->
    <testimonials />

    <when-is-it-good
      :title="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_SECTION_TITLE')"
      :body-paragraph-one-text="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_1_TEXT')"
      :body-paragraph-one-title="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_1_TITLE')"
      :body-paragraph-two-text="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_2_TEXT')"
      :body-paragraph-two-title="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_2_TITLE')"
      :body-paragraph-three-text="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_3_TEXT')"
      :body-paragraph-three-title="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_3_TITLE')"
      :body-paragraph-four-text="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_4_TEXT')"
      :body-paragraph-four-title="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_4_TITLE')"
      :body-paragraph-five-text="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_5_TEXT')"
      :body-paragraph-five-title="$t('ORTHODONTICS_WHEN_IS_IT_GOOD_PARAGRAPH_5_TITLE')"
      :demo-video-id="demoVideoIdWhenIsItGood"
    />

    <our-location
      :title="$t('FOOTER_SECTION_TITLE')"
      :body="''"
      :name="$t('PROVIDER_NAME')"
      :address-line1="$t('PROVIDER_ADDRESS_LINE_1')"
      :address-line2="$t('PROVIDER_ADDRESS_LINE_2')"
      :phone="$t('PROVIDER_CONTACT_PHONE')"
      :email="$t('PROVIDER_CONTACT_EMAIL')"
      :location-img-src="$t('PROVIDER_LOCATION_IMAGE_SRC')"
      :logo-img-src="$t('PROVIDER_LOGO_WHITE_BACKGROUND')"
    />
  </div>
</template>

<script>
  import { loadLanguageAsync } from '@/i18n'
  import validationApiServices from '@/helpers/validation_endpoints'
  import miscUtils from '@/helpers/utils'

  import analyticsLoader from '@/external/google_analytics'

  import LogoPlain from '@/views/sections/general/LogoPlain'
  import HeroPlain from '@/views/sections/general/HeroPlain'
  import AboutCta from '@/views/sections/general/AboutCta'
  import Testimonials from '@/views/sections/general/Testimonials'
  import HowItWorks from '@/views/sections/general/HowItWorks'
  import HowToVideo from '@/views/sections/general/HowToVideo'
  import WhenIsItGood from '@/views/sections/general/WhenIsItGood'
  import OurLocation from '@/views/sections/general/OurLocation'

  export default {
    components: {
      LogoPlain,
      HeroPlain,
      AboutCta,
      Testimonials,
      HowItWorks,
      HowToVideo,
      WhenIsItGood,
      OurLocation,
    },

    data () {
      return {
        clinicWidgetId: '',
        widgetType: '',
        bannerImageSrc: '',
      }
    },

    computed: {
      review1 () {
        return {
          include: this.$t('CUSTOMER_REVIEW_SECTION_REVIEW_1_INCLUDE'),
          review: this.$t('CUSTOMER_REVIEW_SECTION_REVIEW_1_QUOTE'),
          aboutLine1: this.$t('CUSTOMER_REVIEW_SECTION_REVIEW_1_ABOUT_LINE_1'),
          aboutLine2: this.$t('CUSTOMER_REVIEW_SECTION_REVIEW_1_ABOUT_LINE_2'),
          avatar: this.$t('CUSTOMER_REVIEW_SECTION_REVIEW_1_AVATAR_SRC'),
        }
      },
      howItWorksBullets () {
        return [
          {
            text: this.$t('ORTHODONTICS_HOW_IT_WORKS_SECTION_STEP_1_TEXT'),
          },
          {
            text: this.$t('ORTHODONTICS_HOW_IT_WORKS_SECTION_STEP_2_TEXT'),
          },
          {
            text: this.$t('ORTHODONTICS_HOW_IT_WORKS_SECTION_STEP_3_TEXT'),
          },
        ]
      },
      whatHappensNextBullets () {
        return [
          {
            text: this.$t('ORTHODONTICS_WHAT_HAPPENS_NEXT_SECTION_STEP_1_TEXT'),
          },
          {
            text: this.$t('ORTHODONTICS_WHAT_HAPPENS_NEXT_SECTION_STEP_2_TEXT'),
          },
          {
            text: this.$t('ORTHODONTICS_WHAT_HAPPENS_NEXT_SECTION_STEP_3_TEXT'),
          },
        ]
      },
      demoVideoIdHowItWorks () {
        return this._lookupOrEmptyString('ORTHODONTICS_HOW_IT_WORKS_IMAGES_SECTION_VIMEO_VIDEO_LINK_ID')
      },
      demoImageHowItWorks () {
        return this._lookupOrEmptyString('HOW_IT_WORKS_SECTION_IMAGE_SRC')
      },
      demoAvatarImageHowItWorks () {
        return this._lookupOrEmptyString('HOW_IT_WORKS_SECTION_AVATAR_IMAGE_SRC')
      },
      demoVideoIdHowToVideo () {
        return this._lookupOrEmptyString('ORTHODONTICS_HOW_TO_TAKE_IMAGES_SECTION_VIMEO_VIDEO_LINK_ID')
      },
      demoVideoIdWhenIsItGood () {
        return this._lookupOrEmptyString('ORTHODONTICS_WHEN_IS_IT_GOOD_SECTION_VIMEO_VIDEO_LINK_ID')
      },
    },

    async mounted () {
      const clinicWidgetId = this.$route.query.provider
      this.clinicWidgetId = clinicWidgetId

      // NOTE: Fail as fast as possible, which is here on our own hosted page.
      try {
        const response = await validationApiServices.getClinicLocales({ clinicWidgetId: clinicWidgetId })
        this.widgetType = response.data.data.attributes.widget_type
        const messages = response.data.data.attributes.clinic_widget_locales_as_json
        const fallbackLanguage = response.data.data.attributes.fallback_locales_language
        await loadLanguageAsync({ clinicWidgetId, messages, fallbackLanguage })
        this.bannerImageSrc = this.$t('JUMBOTRON_BANNER_IMAGE')
      } catch (e) {
        this.$router.push('/not-found')
        throw e
      }

      try {
        this.setCustomThemeColor()
      } catch (e) {
        // pass
      }

      this.loadWidgetIframeScript(clinicWidgetId)

      const googleAppId = process.env.VUE_APP_ADENT_GOOGLE_ANALYTICS_ID
      this.loadGoogleAnalytics(googleAppId, 'google-analytics-wrapper-div')
    },

    methods: {
      setCustomThemeColor () {
        /** See note for Funnel Widget in separate repo.
        */
        const _colorFromLocales = 'PROVIDER_THEME_COLOR'
        let customThemeColor = ''
        if (miscUtils.isValidHex(this.$t(_colorFromLocales))) {
          customThemeColor = this.$t(_colorFromLocales)
        }
        const isColorCustomized = (customThemeColor && !(customThemeColor === _colorFromLocales))
        if (isColorCustomized) {
          if (!customThemeColor.startsWith('#')) {
            customThemeColor = `#${customThemeColor}`
          }
          if (miscUtils.isValidHex(customThemeColor)) {
            this.$vuetify.theme.themes.light.primary = customThemeColor
          } else {
            // Add airbrake
          }
        }
      },

      _lookupOrEmptyString (lookup) {
        let videoId = ''
        if (lookup !== this.$t(lookup)) {
          videoId = this.$t(lookup)
        }
        return videoId
      },

      loadGoogleAnalytics (appId, divId) {
        if (!appId) { return }
        const scriptTemplate = analyticsLoader.load(appId)
        const wrapperDiv = document.createElement('div')
        wrapperDiv.setAttribute('id', divId)
        wrapperDiv.innerHTML = scriptTemplate
        document.head.appendChild(wrapperDiv)
      },

      loadWidgetIframeScript (clinicWidgetId) {
        const widgetScriptSrc = process.env.VUE_APP_WIDGET_IFRAME_SCRIPT_SRC
        const iframeUrl = miscUtils.buildIframeUrl({
          widgetType: this.widgetType,
          envVariables: process.env,
        })

        if (!widgetScriptSrc) { return }

        const widgetScript = document.createElement('script')

        // Base variables
        widgetScript.setAttribute('id', 'adent-health')
        widgetScript.setAttribute('type', 'text/javascript')
        widgetScript.setAttribute('async', 'async')
        widgetScript.setAttribute('src', widgetScriptSrc)

        // Configs
        widgetScript.setAttribute('data-provider-id', clinicWidgetId)
        widgetScript.setAttribute('data-iframe-base-url', iframeUrl)
        widgetScript.setAttribute('data-include-button', 'false')
        widgetScript.setAttribute('data-include-headsup', 'false')

        document.head.appendChild(widgetScript)
      },
    },

  }
</script>
